import Dexie from 'dexie';

const DB_NAME = 'FigshelfDatabaseDB';
const DB_VERSION = 1;

export const makeDatabaseHomeKey = ({ userId }) => {
  return `home:${userId || 'anon'}`;
};

class DatabaseCacheDb extends Dexie {
  constructor() {
    super(DB_NAME);

    this.version(DB_VERSION).stores({
      databaseHome: 'key, updatedAt',
    });

    this.databaseHome = this.table('databaseHome');
  }
}

let dbInstance = null;

const isDatabaseClosedError = (error) => {
  if (!error) return false;
  if (error?.name === 'DatabaseClosedError') return true;
  if (typeof error?.message === 'string' && error.message.toLowerCase().includes('database has been closed')) {
    return true;
  }
  if (typeof error?.message === 'string' && error.message.toLowerCase().includes('db.open() was cancelled')) {
    return true;
  }
  return false;
};

const resetDatabaseCacheDb = () => {
  // Do not call db.close() here.
  // Dexie can throw/reject during close/open cancellation races (e.g. after indexedDB.deleteDatabase()),
  // which can surface as unhandled rejections. Dropping the singleton reference is enough; a fresh
  // instance will be created on the next read/write.
  dbInstance = null;
};

export const getDatabaseCacheDb = () => {
  if (dbInstance && typeof dbInstance.isOpen === 'function' && !dbInstance.isOpen()) {
    resetDatabaseCacheDb();
  }

  if (!dbInstance) {
    dbInstance = new DatabaseCacheDb();
  }
  return dbInstance;
};

export const getCachedDatabaseHome = async (key) => {
  if (!key) return null;
  try {
    const db = getDatabaseCacheDb();
    const row = await db.databaseHome.get(key);
    return row?.data || null;
  } catch (error) {
    if (isDatabaseClosedError(error)) {
      resetDatabaseCacheDb();
      const db = getDatabaseCacheDb();
      const row = await db.databaseHome.get(key);
      return row?.data || null;
    }
    throw error;
  }
};

export const cacheDatabaseHome = async (key, payload) => {
  if (!key || !payload) return;
  try {
    const db = getDatabaseCacheDb();
    await db.databaseHome.put({
      key,
      updatedAt: new Date().toISOString(),
      data: payload,
    });
  } catch (error) {
    if (isDatabaseClosedError(error)) {
      resetDatabaseCacheDb();
      const db = getDatabaseCacheDb();
      await db.databaseHome.put({
        key,
        updatedAt: new Date().toISOString(),
        data: payload,
      });
      return;
    }
    throw error;
  }
};
